<div *ngIf="formGroup" fxLayout="column" style="padding: 3px; min-height: 320px" [formGroup]="formGroup">
    <!-- geolocation filter type -->
    <div fxLayout="row">
        <mat-radio-group class="geolocation-radio-group">
            <mat-radio-button value="1" checked="{{this.filterTypeId === 1}}" (click)="filterTypeChanged(1)">
                {{ 'Header.Geolocation.LocationBased' | translate }}
            </mat-radio-button>
            <mat-radio-button value="2" checked="{{this.filterTypeId === 2}}" (click)="filterTypeChanged(2)">
                {{ 'Header.Geolocation.MapBased' | translate }}
            </mat-radio-button>
        </mat-radio-group>
    </div>

    <!-- distance -->
    <div fxLayout="row">
        <span class="distance-label">{{ 'Header.Within' | translate }}</span>
        <app-form-field [formGroup]="formGroup"
                        fieldId="distance"
                        fieldControlName="distance"
                        col="6"
                        type="number"
                        class="geolocation-textbox"
                        [validatorOrOpts]="[
                            Validators.min(1),
                            Validators.max(999),
                            Validators.maxLength(3)]"
                        [formState]="distance">
        </app-form-field>
        <span class="distance-label">{{ 'Header.MilesOf' | translate }}</span>
    </div>

    <div fxLayout="row" *ngIf="filterTypeId === 1">
        <!-- location -->
        <app-dropdown-form-field *ngIf="IsLocationListLoaded"
                                 [formGroup]="formGroup"
                                 formControlName="locationId"
                                 fieldLabel="{{ 'Header.SelectLocation' }}"
                                 localizeOptions="false"
                                 class="location-dropdown"
                                 [options]="locationList"
                                 (selectionChange)="onLocationIdChange($event)"
                                 [enableVirtualization]="false">
        </app-dropdown-form-field>
    </div>

    <div fxLayout="row" *ngIf="filterTypeId === 2">
        <div fxLayout="column">
            <div fxLayout="row">
                <!-- latitude -->
                <app-form-field [formGroup]="formGroup"
                                fieldLabel="Header.Geolocation.Latitude"
                                fieldId="centerLat"
                                fieldControlName="centerLat"
                                col="9"
                                type="number"
                                class="geolocation-textbox"
                                [formState]="centerLat">
                </app-form-field>
            </div>
            <div fxLayout="row">
                <!-- longitude -->
                <app-form-field [formGroup]="formGroup"
                                fieldLabel="Header.Geolocation.Longitude"
                                fieldId="centerLon"
                                fieldControlName="centerLon"
                                col="9"
                                type="number"
                                class="geolocation-textbox"
                                [formState]="centerLon">
                </app-form-field>
            </div>
        </div>
    </div>

    <div fxLayout="row" style="margin-top: 10px;justify-content: flex-end;">
        <div class="button-wrapper">
            <button mat-flat-button color="primary" class="small-button" (click)="applyFilterClicked()" [disabled]="disableApply()">Apply</button>
            <button mat-flat-button color="secondary" class="small-button" (click)="clearFilter()" [disabled]="disableClear()">Clear</button>
            <div>
            </div>
        </div>
    </div>
    <div id="geolocationBottom"></div>
</div>
